import type { JSX } from 'react';
import { LandingPage } from '@features/landing/LandingPage';

/**
 * Root da aplicacao. Toda landing vive dentro de `<LandingPage />` — o `<App />`
 * mantem-se como passagem fina (clean-code §3) e ponto de injecao futuro para
 * Providers / ErrorBoundary quando alguma dependencia o exigir (YAGNI ate la).
 */
const App = (): JSX.Element => <LandingPage />;

export default App;
